import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '什么是换妻一族？',
    answer: '换妻一族是指夫妻双方在充分沟通、自愿同意的前提下，与其他伴侣进行交换性探索的成人群体。这是一种建立在信任、尊重和明确规则基础上的非传统亲密关系实践形式。参与者通常强调"自愿、平等、安全、隐私"四大核心原则。',
  },
  {
    question: '换妻行为在中国合法吗？',
    answer: '换妻行为在中国法律框架下存在一定的灰色地带。《刑法》第三百零一条规定的聚众淫乱罪，当涉及三人以上同时参与性活动时可能被触发。建议所有对此感兴趣的人士务必详细了解相关法律条文，充分评估潜在法律风险后再做决定。',
  },
  {
    question: '如何保证换妻活动中的性健康安全？',
    answer: '性健康安全是换妻活动的基石。核心措施包括：每三个月进行一次全面STI检测并要求伴侣出示近期报告、全程正确使用安全套等屏障保护工具、接种HPV和乙肝等疫苗、活动后保持2-4周健康观察。任何参与者都有权利在任何时候拒绝不安全的性行为。',
  },
  {
    question: '换妻会影响夫妻感情吗？',
    answer: '这个问题没有统一的答案，结果因人而异。研究表明，关系基础牢固、沟通充分、规则明确的伴侣更可能获得积极体验，甚至强化情感纽带。而关系本身存在裂痕、缺乏信任或沟通不畅的伴侣，换妻可能放大已有的问题。核心原则是：换妻不能用来"修复"关系，而应该是在健康关系基础上的共同探索。',
  },
  {
    question: '换妻与出轨有什么区别？',
    answer: '根本区别在于"知情同意"。换妻是伴侣双方经过充分沟通、自愿同意、共同参与的行为，核心伴侣对彼此的活动完全知情并认可。而出轨则是隐瞒、欺骗伴侣的背信行为。换妻文化强调的是透明、诚实和共同决策，这与出轨的欺骗性本质截然相反。',
  },
  {
    question: '新人如何安全地开始换妻探索？',
    answer: '建议循序渐进：首先与伴侣进行3-6个月的深度沟通和心理建设，建立共同的认知基础；其次从"同房不换"等低强度形式开始，逐步升级；选择有经验且口碑良好的引导伴侣；务必在活动前明确双方的界限和退出机制。切忌在压力、冲动或准备不足的情况下贸然参与。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于换妻文化，你最关心的问题都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}